module.exports = __webpack_public_path__ + "assets/home-icon.6bdedde1.svg";